import ResourceStore from "../../shared/services/ResourceStore";

const NameOptions = {
  vat: "VAT",
  gst: "GST"
};

export const NO_TAX_ID = "0";

class TaxStore extends ResourceStore {
  _baseUrl (_params) {
    return "/api/v4";
  }

  async filteredWithEmptyTax (merchantId) {
    let response = await this.filter(merchantId);

    response.collection.push({
      id: NO_TAX_ID,
      name: "No Tax",
      rate: 0
    });

    return response;
  }
};

export default new TaxStore("tax");
export { TaxStore, NameOptions };
